export default __webpack_public_path__ + "static/media/hht2_ep14_speaking_02.87d95e3f.png";